import type { ContractOffer, ContractTerms } from "./contract-orders.js";
import type { RunContractState } from "./contracts.js";
import { REGIONS } from "./world-layout.js";

const PATROL_GAMEPLAY_OFFSET = { x: 2200, y: 0 };

export function relocatePatrolGameplayPoint(point: { x: number; y: number }): { x: number; y: number } {
  const from = REGIONS.find((region) => region.id === "patrol");
  const to = REGIONS.find((region) => region.id === "wrecks");
  if (!from || !to) throw new Error("Station and combat regions must exist");
  if (point.x < from.x || point.x >= from.x + from.width ||
      point.y < from.y || point.y >= from.y + from.height)
    return { ...point };
  const relocated = { x: point.x + PATROL_GAMEPLAY_OFFSET.x, y: point.y + PATROL_GAMEPLAY_OFFSET.y };
  if (relocated.x < to.x || relocated.x >= to.x + to.width ||
      relocated.y < to.y || relocated.y >= to.y + to.height)
    throw new Error("Relocated patrol gameplay must fit the combat region");
  return relocated;
}

export function relocatePatrolContractTerms(terms: ContractTerms): ContractTerms {
  const result = structuredClone(terms);
  if (result.sectorId !== "patrol") return result;
  result.sectorId = "wrecks";
  result.objective = { ...result.objective, ...relocatePatrolGameplayPoint(result.objective) };
  if (result.escort)
    result.escort.path = result.escort.path.map(relocatePatrolGameplayPoint);
  if (result.contentVersion === "contract-orders-v3" && result.cargoOriginSectorId === "patrol")
    result.cargoOriginSectorId = "wrecks";
  return result;
}

export function relocatePatrolContractOffer(offer: ContractOffer): ContractOffer {
  return {
    ...offer,
    standard: relocatePatrolContractTerms(offer.standard),
    advanced: relocatePatrolContractTerms(offer.advanced),
  };
}

export function relocatePatrolRunContract(contract: RunContractState): RunContractState {
  const result = structuredClone(contract);
  if (result.sectorId !== "patrol" || result.terms.sectorId !== "patrol") return result;
  result.terms = relocatePatrolContractTerms(result.terms);
  result.sectorId = result.terms.sectorId;
  return result;
}
